import { isIDevice } from './browser'

/** The tab a docked floater leaves on screen */
export const EDGE_WIDTH = isIDevice ? 34 : 48

/** The left (-1) or right (1) screen edge */
export type Edge = -1 | 1

/** A docked floater's x: only its tab is on screen */
export const dockX = (
    edge: Edge,
    width: number,
    windowWidth: number,
    edgeWidth = EDGE_WIDTH,
) => (edge === 1 ? windowWidth - edgeWidth : -(width - edgeWidth))

/** Back on screen beside the edge it left */
export const expandX = (edge: Edge, width: number, windowWidth: number) =>
    edge === 1 ? windowWidth - (width + 26) : 12

/**
 * Where a released floater settles: more than 30% off screen docks it to
 * that edge, partly off screen brings it back beside the edge, and on
 * screen it stays put.
 */
export const resolveShrinkToEdge = (
    x: number,
    width: number,
    windowWidth: number,
    edgeWidth = EDGE_WIDTH,
): { x: number; shrinkToEdge: Edge | false } => {
    if (x + width * 0.7 >= windowWidth)
        return { x: dockX(1, width, windowWidth, edgeWidth), shrinkToEdge: 1 }
    if (x < -(0.3 * width))
        return {
            x: dockX(-1, width, windowWidth, edgeWidth),
            shrinkToEdge: -1,
        }
    if (x + width > windowWidth)
        return { x: expandX(1, width, windowWidth), shrinkToEdge: false }
    if (x < 0)
        return { x: expandX(-1, width, windowWidth), shrinkToEdge: false }
    return { x, shrinkToEdge: false }
}
